package com.anjuros.website.templates.template5.util

import com.anjuros.website.components.shared.CompanyDetailsType
import com.anjuros.website.components.shared.DetailsType
import com.anjuros.website.templates.template5.util.Template5Constants.CLIENTS_COMPANY
import com.anjuros.website.templates.template5.util.Template5Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.template5.util.Template5Constants.CLIENTS_INSTAGRAM_NAME
import com.anjuros.website.templates.template5.util.Template5Constants.CLIENTS_PHONE
import com.anjuros.website.templates.template5.util.Template5Constants.CLIENTS_SERVICE_AREA

enum class Template5CompanyDetails: CompanyDetailsType {
    CLIENTS_EMAIL_INFO {
        override fun value(): String {
            return CLIENTS_EMAIL
        }

        override fun getType(): DetailsType {
            return DetailsType.EMAIL
        }
    },
    CLIENTS_COMPANY_INFO {
        override fun value(): String {
            return CLIENTS_COMPANY
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY
        }
    },

    CLIENTS_COMPANY_NAME {
        override fun value(): String {
            return CLIENTS_COMPANY
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_NAME
        }
    },

    CLIENTS_SERVICE_AREA_INFO {
        override fun value(): String {
            return CLIENTS_SERVICE_AREA
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_SERVICE_AREA
        }
    },

    CLIENTS_PHONE_INFO {
        override fun value(): String {
            return CLIENTS_PHONE
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_PHONE
        }
    },
    CLIENTS_INSTAGRAM_INFO {
        override fun value(): String {
            return CLIENTS_INSTAGRAM_NAME
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_INSTAGRAM
        }
    },
}